// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navbar_nav__3DM4X","logo":"Navbar_logo__3ej6N","navigation":"Navbar_navigation__wdKDS","active":"Navbar_active__2gZO3"};